import { DOCUMENT_TYPE_META, type DocumentType, formatMoney } from '@makila/fiscal';

export const mt = (v: unknown) => formatMoney(String(v ?? 0));
export const date = (d: string | null | undefined) => (d ? d.slice(0, 10).split('-').reverse().join('/') : '—');
export const dateTime = (d: string | null | undefined) => (d ? new Date(d).toLocaleString('pt-MZ', { dateStyle: 'short', timeStyle: 'short' }) : '—');
export const docLabel = (t: string) => DOCUMENT_TYPE_META[t as DocumentType]?.label ?? t;
export const today = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'Africa/Maputo' }).format(new Date());
export const monthStart = () => today().slice(0, 8) + '01';
export const prevPeriod = () => {
  const [y, m] = today().split('-').map(Number) as [number, number];
  const d = new Date(Date.UTC(y, m - 2, 1));
  return d.toISOString().slice(0, 7);
};
